module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?51c686b86bc12382579d8283b7e76b6b";